var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 62.832",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Undo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-undo",
    "data-name": "Icon ionic-ios-undo",
    d: "M82.214,61.849c0-3.5.75-17.335-10.141-28.333C64.861,26.249,55.667,22.5,42.9,21.822a.722.722,0,0,1-.678-.714V6.343a.719.719,0,0,0-1.107-.607L2.571,31.123a.717.717,0,0,0,0,1.2L41.116,57.707a.709.709,0,0,0,1.107-.607V42.531a.714.714,0,0,1,.75-.714,41.98,41.98,0,0,1,17.335,4.142c6.445,2.892,13.015,9.087,16.871,14.907A38.23,38.23,0,0,1,81,67.954a.792.792,0,0,0,.732.5h.518C82.232,66.365,82.214,63.687,82.214,61.849Z",
    transform: "translate(-2.25 -5.622)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.fd1c3d37c84e53d2734f8e9e9daf3f44.svg";
export { ForwardRef as ReactComponent };